import React from 'react';
import "./Footer.css"

function Footer () {
  return (
    <div className="footer-container">
      <div className="footer-parent">
        <img
          src={require("../../../assets/Home/shape-bg.png")}
          alt="you have a problem with the internet"
        />
      </div>
    </div>
  );
}

export default Footer;